import { z } from "zod";
import { MethodsInputSchema } from "../methodsInput";

export const TransientFlowInputsSchema = MethodsInputSchema.extend({
  exploitationFlow: z.number().positive(),
  saturatedThicknessBase: z.number(),
  saturatedThicknessTop: z.number(),
  hydraulicConductivity: z.number().positive(),
  hydraulicGradient: z.number(),
  effectivePorosity: z.number().positive(),
  recharge: z.number().positive(),
}).refine((data) => data.saturatedThicknessBase > data.saturatedThicknessTop, {
  path: ["saturatedThicknessBase"],
});

export type TransientFlowInputs = z.infer<typeof TransientFlowInputsSchema>;
